module.exports = __webpack_public_path__ + "static/img/大量钻机.7b31ef8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/instructionsIimags/大量钻机.png
// module id = scoG
// module chunks = 1